import Swal from 'sweetalert2'
import { UserType } from '~/enums'
import { useUserStore } from '~/store/userStore'
import { useRouteStore } from '~/store/routeStore'


export default defineNuxtRouteMiddleware((to, from) => {
  const userStore = useUserStore()
  const routeStore = useRouteStore()
  const userPermission = userStore.userRoutePermission
  
  // 로그인 페이지는 모든 사용자가 접근 가능
  if (to.path === '/toc/user/login') {
    return
  }
  
  // 로그인하지 않은 경우 로그인 페이지로 리다이렉트
  if (!userStore.loginUserInfo?.userSeq) {
    Swal.fire({
      html: `<p style="font-size: 15px;">로그인 후 이용해주세요.</p>`,
      confirmButtonColor: "#1949e9",
      confirmButtonText: "확인",
      width: "85%"
    });
    return navigateTo('/toc/user/login')
  }

  // design-toc 라우트에 대한 권한 확인
  if (to.path.startsWith('/toc')) {
    const userType = userStore.getUserType
    // TODO: API 기능 완성 후 활성화 예정 - 현재는 router.json만 사용
    // const userRouteList = routeStore.userRouteList;

    // console.log('Auth guard - userRouteList:', userRouteList);
    console.log('Auth guard - userType:', userType);
    console.log('Auth guard - to.path:', to.path);

    // TODO: API 기능 완성 후 활성화 예정
    // // userRouteList가 배열인 경우 첫 번째 요소를 사용, 객체인 경우 그대로 사용
    // const routeConfig = Array.isArray(userRouteList) ? userRouteList[0] : userRouteList;
    //
    // // getAuthRouterConfig 값이 있는 경우 권한 체크 없이 바로 통과
    // if (routeConfig && routeConfig.routes && routeConfig.routes.length > 0) {
    //   console.log('getAuthRouterConfig found, skipping permission check for:', to.path);
    //   console.log('Route config:', routeConfig);
    //   return; // API 데이터가 있으면 권한 체크 없이 바로 통과
    // }
    //
    // // userRouteList가 로드 중이거나 아직 로드되지 않은 경우 임시로 허용
    // // (로그인 과정에서 라우트가 아직 로드되지 않았을 수 있음)
    // if (!userRouteList || (Array.isArray(userRouteList) && userRouteList.length === 0)) {
    //   console.log('userRouteList not loaded yet, temporarily allowing access to:', to.path);
    //   // dashboard/default로의 접근은 허용 (로그인 후 기본 페이지)
    //   if (to.path === '/toc/dashboard/default') {
    //     return;
    //   }
    //   // 다른 페이지는 잠시 대기 후 다시 체크하거나 기본 로직 사용
    // }

    // router.json 기반 userAuthGroup 권한 체크 사용
    console.log('Using userAuthGroup-based route permission check for:', to.path);
    
    // 권한에 따른 라우트 접근 제어
    if (userType === UserType.Manager || userType === UserType.Admin) {
      // 관리자는 모든 design-toc 라우트에 접근 가능
      console.log('Manager/Admin access granted for:', to.path);
      return
    } else if (userType === UserType.Owner) {
      if (to.path === '/toc') {
        console.log('Owner access allowed for root /toc path');
        return;
      }
      // Owner은 dashboard와 관련 라우트에만 접근 가능
      // siteone일 때 sites-detail-default는 /toc/dashboard/sites/default 경로를 사용할 수 있으므로 허용
      if (to.path.startsWith('/toc/dashboard') || 
          to.path.startsWith('/toc/sites') ||
          to.path.startsWith('/toc/setting') ||
          to.path.startsWith('/toc/analysis') ||
          to.path.startsWith('/toc/user-privacy-service')) {
        console.log('Owner access granted for:', to.path, 'userPermission:', userPermission);
        return
      } else {
        // siteone 또는 siteover일 때 추가 경로 체크
        if (userPermission === 'siteone' || userPermission === 'siteover') {
          // sites-detail 관련 경로 허용
          if (to.path.includes('sites') && (to.path.includes('detail') || to.path.includes('default'))) {
            console.log('Owner access granted for sites route:', to.path, 'userPermission:', userPermission);
            return;
          }
        }
        // 권한이 없는 페이지는 dashboard로 리다이렉트
        console.log('Owner access denied for:', to.path, 'redirecting to dashboard', 'userPermission:', userPermission);
        return navigateTo('/toc/dashboard')
      }
    } else {
      // 기타 사용자는 로그인 페이지로 리다이렉트
      console.log('Access denied for user type:', userType, 'redirecting to login');
      return navigateTo('/toc/user/login')
    }
  }
})
